<template>
  <ui-modal-layout v-if="paymentHistory" :title="tr('Online bank card payment')" :icon="CreditCardIcon">
    <payment-history-details :entity="paymentHistory" />

    <div v-if="!clientSecret || !stripeCardInputReady" class="flex justify-center py-4">
      <loader-circle-icon class="size-6 animate-spin text-primary" />
    </div>

    <template v-if="clientSecret">
      <stripe-card-input
        ref="stripeForm"
        :client-secret="clientSecret"
        @ready="() => stripeCardInputReady = true"
        @success="() => runOnSuccess()"
        @error="(err) => error(err)"
      />
      <ui-button class="w-full" :disabled="isPaying" @click="() => $refs.stripeForm.save()">
        <loader-circle-icon v-if="isPaying" class="animate-spin" />
        {{ tr('Pay') }} - {{ formatPrice(paymentHistory.gross, '€') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { CreditCard, LoaderCircle } from '@lucide/vue';
import { markRaw } from 'vue';

import PaymentHistory from '@/entities/PaymentHistory';
import PaymentHistoryService from '@/services/PaymentHistory';
import PaymentHistoryDetails from '@/ui/components/PaymentHistoryDetails.vue';
import StripeCardInput from '@/ui/components/StripeCardInput.vue';
import { formatPrice } from '@/utils/number';

export default {
  name: 'PaymentModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
    PaymentHistoryDetails,
    StripeCardInput,
  },
  props: {
    paymentHistory: {
      type: PaymentHistory,
      required: true,
    },
    onSuccess: {
      type: [ Function, null ],
      required: false,
      default: null,
    },
  },
  data: () => ({
    CreditCardIcon: markRaw(CreditCard),
    formLoaded: false,
    clientSecret: null,
    stripeCardInputReady: false,
  }),
  computed: {
    isPaying() {
      return this.formLoaded && this.$refs.stripeForm && this.$refs.stripeForm.isLoading;
    },
  },
  watch: {
    isPaying(val) {
      if (!val) {
        if (this.paymentHistoryChangeStatusTimer !== null) {
          clearTimeout(this.paymentHistoryChangeStatusTimer);
        }
      }
    },
  },
  created() {
    PaymentHistoryService.generatePaymentIntent(this.paymentHistory.id)
      .then(resp => {
        this.clientSecret = resp.client_secret;
        this.$nextTick(() => this.formLoaded = true);

        return resp;
      })
      .catch(err => {
        this.error(err);
        this.$fullscreenModal.closeAll();
      });
  },
  methods: {
    formatPrice,
    runOnSuccess() {
      if (this.onSuccess) {
        this.onSuccess();
      }

      this.$emit('close');
    },
  },
};
</script>
